import { CSSProperties } from 'react';

export const ERROR_CONTAINER_STYLE: CSSProperties = {
  paddingTop: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const PREPARING_IMAGE_SX = {
  width: '100%',
  height: '100%',
  minHeight: '160px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
